import React, { useState } from "react";
import { DescriptionContainer, Text } from "./styled";
import Typography from "../Typography";
import { ShowMoreButton } from "../ShowMoreButton";

export function TruncatedDescription({ text, limit = 239 }) {
  const [showFullDescription, setShowFullDescription] = useState(false);

  const shouldTruncate = text.length > limit;
  const truncatedDescription = text.slice(0, limit) + "...";

  const toggleDescription = () => {
    setShowFullDescription(!showFullDescription);
  };

  return (
    <DescriptionContainer>
      <Typography as={Text} color="secondary">
        {shouldTruncate && !showFullDescription ? truncatedDescription : text}
      </Typography>
      {shouldTruncate && (
        <ShowMoreButton
          isExpanded={showFullDescription}
          onClick={toggleDescription}
        />
      )}
    </DescriptionContainer>
  );
}
